import { didApiUrl } from '@/environment';
import { authenticatedAxios } from '@/services/auth';
import { IKnowledge, IKnowledgeDocument } from '@d-id/types';

export const createKnowledge = async (knowledge: IKnowledge) => {
    const response = await authenticatedAxios?.post(`${didApiUrl}/knowledge`, knowledge);
    return response?.data;
};

export const updateKnowledge = async (knowledge_id: string, knowledge: IKnowledge) => {
    const response = await authenticatedAxios?.patch(`${didApiUrl}/knowledge/${knowledge_id}`, knowledge);
    return response?.data;
};

export const getKnowledge = async (knowledge_id: string) => {
    const response = await authenticatedAxios?.get<IKnowledge>(`${didApiUrl}/knowledge/${knowledge_id}`);
    return response?.data;
};

export const deleteKnowledge = async (knowledge_id: string) => {
    const response = await authenticatedAxios?.delete(`${didApiUrl}/knowledge/${knowledge_id}`);
    return response.data;
};

export const createKnowledgeDocument = async (knowledge_id: string, document: IKnowledgeDocument) => {
    const response = await authenticatedAxios?.post(`${didApiUrl}/knowledge/${knowledge_id}/documents`, document);
    return response?.data;
};

export const getKnowledgeDocuments = async (knowledge_id: string) => {
    const response = await authenticatedAxios?.get(`${didApiUrl}/knowledge/${knowledge_id}/documents`);
    return response?.data;
};

export const getKnowledgeDocument = async (knowledge_id: string, document_id: string) => {
    const response = await authenticatedAxios?.get(`${didApiUrl}/knowledge/${knowledge_id}/documents/${document_id}`);
    return response?.data;
};

export const deleteKnowledgeDocument = async (knowledge_id: string, document_id: string) => {
    const response = await authenticatedAxios?.delete(`${didApiUrl}/knowledge/${knowledge_id}/documents/${document_id}`);
    return response?.data;
};

export const validateKnowledgeDocuments = async (documents: IKnowledgeDocument[]) => {
    const response = await authenticatedAxios?.post(`${didApiUrl}/knowledge/validate`, documents);
    return response?.data;
};
